import { render, staticRenderFns } from "./consult.vue?vue&type=template&id=6d18cbbf&scoped=true"
import script from "./consult.vue?vue&type=script&lang=js"
export * from "./consult.vue?vue&type=script&lang=js"
import style0 from "./consult.vue?vue&type=style&index=0&id=6d18cbbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18cbbf",
  null
  
)

export default component.exports